<template>
  <input
    v-model="query"
    type="search"
  >
</template>
<!-- Using the options API here because Vue InstantSearch only supplies a mixin, not a composable -->
<!-- eslint-disable vue/component-api-style -->
<script lang='ts'>
import { connectSearchBox } from 'instantsearch.js/es/connectors'
import { createWidgetMixin } from 'vue-instantsearch/vue3/es'
import { defineComponent } from 'vue'

// Lifted wholesale from https://www.algolia.com/doc/guides/building-search-ui/going-further/improve-performance/vue/?client=Vue+3#debouncing
export default defineComponent({
  name: 'DebouncedSearchBox',
  mixins: [
    createWidgetMixin({ connector: connectSearchBox }),
  ],
  props: {
    delay: {
      type: Number,
      default: 200,
      required: false,
    },
  },
  data() {
    return {
      timerId: null,
      localQuery: '',
    }
  },
  computed: {
    query: {
      get(): string {
        return this.localQuery
      },
      set(val: string): void {
        this.localQuery = val
        if (this.timerId) {
          clearTimeout(this.timerId)
        }
        this.timerId = setTimeout(() => {
          this.state.refine(this.localQuery)
        }, this.delay)
      },
    },
  },
  beforeUnmount(): void {
    if (this.timerId) {
      clearTimeout(this.timerId)
    }
  },
})
</script>
